import requestWrapper from "../utils/requestWrapper";
import { IGenericResponse } from "@/services/interfaces";

export default async (): Promise<IGenericResponse> => {
  const request = {
    url: `/api/cart/products/clear`,
    method: "POST",
  };

  return await requestWrapper(request);
};
